import {
  AppBase,
  baseFromDoc,
  FirestoreBaseDoc,
  makeDocConverter,
} from '../base/firestore-model-base'

export type SchoolManualItemDoc = {
  category: string
  title: string
  detail: string
}

export type SchoolManualItem = {
  category: string
  title: string
  detail: string
}

/** Google Drive 等へのマニュアルPDFリンク（一覧表示用） */
export type SchoolManualLink = {
  title: string
  detail: string
  link: string
}

/**
 * config/school_manual ドキュメント
 *
 * - `manuals`: FAQ（カテゴリ別Q&A）
 * - `manual_links`: 外部マニュアルへのリンク一覧
 */
export type SchoolManualConfigDoc = FirestoreBaseDoc & {
  manuals: SchoolManualItemDoc[]
  manual_links?: SchoolManualLink[]
}

export type SchoolManualConfig = AppBase & {
  manuals: SchoolManualItem[]
  manual_links: SchoolManualLink[]
}

export const schoolManualConfigDocConverter = makeDocConverter<SchoolManualConfigDoc>()

function toSchoolManualItem(doc: SchoolManualItemDoc): SchoolManualItem {
  return {
    category: doc.category ?? '',
    title: doc.title ?? '',
    detail: doc.detail ?? '',
  }
}

function toSchoolManualLink(link: SchoolManualLink): SchoolManualLink {
  return {
    title: link.title ?? '',
    detail: link.detail ?? '',
    link: link.link ?? '',
  }
}

export function toSchoolManualConfig(
  id: string,
  doc: SchoolManualConfigDoc,
  path: string,
): SchoolManualConfig {
  const base = baseFromDoc(id, doc, path)
  return {
    ...base,
    manuals: (doc.manuals ?? []).map(toSchoolManualItem),
    manual_links: (doc.manual_links ?? []).map(toSchoolManualLink),
  }
}
